import { getApi, APIS, postApi } from "../utils/api-utils";
import { USER_ROLE } from "./constants";

export const getUsers = async (state: number, buildingId: string) => {
    let params: any = {
        state: state,
        buildingId: buildingId
    };

    return await getApi(APIS.USER_API, '/users', { queryStringParameters: params })
}

export const getWalletPasses = async (tenantId: string, userId: string) => {
    const result = await getApi(APIS.WALLET_API, '/user/wallet-passes', {
        queryStringParameters: { tenantId, userId }
    });
    return Array.isArray(result) ? result : result?.passes || [];
}

export const reconcileWalletPasses = async (tenantId: string, userId: string) => {
    await postApi(APIS.WALLET_API, '/user/wallet/reconcile', {
        tenantId,
        userId
    });
}

export const loadWalletPassDetails = async (tenantId: string, userId: string, shouldReconcile = true) => {
    let reconciliationSucceeded = false;
    let reconciliationError: unknown;
    let walletCredentials: any[] | undefined;
    let walletPassLoadError: unknown;

    if (shouldReconcile) {
        try {
            await reconcileWalletPasses(tenantId, userId);
            reconciliationSucceeded = true;
        } catch (error) {
            reconciliationError = error;
        }
    }

    try {
        walletCredentials = await getWalletPasses(tenantId, userId);
    } catch (error) {
        walletPassLoadError = error;
    }

    return {
        reconciliationSucceeded,
        reconciliationError,
        walletCredentials,
        walletPassLoadError
    };
}

export const addUser = async (data: any) => {
    data.email = data.email.toLowerCase();
    return await postApi(APIS.USER_API, '/user', data);
}

export const changeRole = async (userId: string, tenantId: string, currRole: string, buildingId: string) => {
    const params = {
        userId,
        tenantId,
        role: currRole === USER_ROLE.USER ? USER_ROLE.ADMIN : USER_ROLE.USER,
        buildingId
    }
    await postApi(APIS.USER_API, '/user/usergroup', params);
}

export const changeState = async (userId: string, tenantId: string, buildingId: string) => {
    const params = {
        userId,
        tenantId,
        buildingId
    }
    await postApi(APIS.USER_API, '/user/state', params);
}

export const resendWelcomeEmail = async (tenantId: string, userId: string) => {
    const params = {
        tenantId,
        userId
    }
    await postApi(APIS.USER_API, '/user/send-welcome-email', params);
}

export const revokeAccessCredential = async (userId: string, tenantId: string, buildingId: string) => {
    const params = {
        userId,
        tenantId,
        buildingId
    }
    await postApi(APIS.USER_API, '/user/revoke-access-credential', params);
}

export const suspendWalletCredential = async (passId: string) => {
    await postApi(APIS.WALLET_API, '/user/wallet/suspend', {
        passId,
        reason: 'ADMIN_WEBAPP_SUSPEND'
    });
}

export const resumeWalletCredential = async (passId: string) => {
    await postApi(APIS.WALLET_API, '/user/wallet/resume', {
        passId,
        reason: 'ADMIN_WEBAPP_RESUME'
    });
}

export const revokeWalletCredential = async (passId: string) => {
    await postApi(APIS.WALLET_API, '/user/wallet/revoke', {
        passId,
        reason: 'ADMIN_WEBAPP_REVOKE'
    });
}

export const editUser = async (params: any) => {
    await postApi(APIS.USER_API, '/user/edit', params);
}

export const isUserExistError = (e: any) => {
    return e && e.response && e.response.data && e.response.data.message === 'User account already exists';
}
